import { CanActivateChildFn, GuardResult, Router } from '@angular/router';
import { SessionStoreRepository } from '../../repositories/session.repository';
import { inject } from '@angular/core';

export const authGuard: CanActivateChildFn = (): GuardResult => {
    const sessionService = inject(SessionStoreRepository);
    const router = inject(Router);

    return sessionService.isLoggedIn() || router.createUrlTree(['/welcome']);
}

export const notAuthGuard: CanActivateChildFn = (): GuardResult => {
    const sessionService = inject(SessionStoreRepository);
    const router = inject(Router);

    return !sessionService.isLoggedIn() || router.createUrlTree(['/authenticated']);
}